import React, { useEffect, Fragment, useState, useMemo } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Select, Drawer, Menu, Dropdown, Checkbox, Tag, Popover, Radio, Space, Modal, Spin, Tooltip,
  Divider,
} from 'antd';
import dayjs from 'dayjs';
import { faAnglesRight, faCaretDown, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ControlOutlined, CopyOutlined, FilterOutlined, UnlockOutlined, LockOutlined } from '@ant-design/icons';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Helpers from '@Apis/helpers';
import { toISTDate } from '@Apis/constants';
import searchIcon from '@Images/icons/icon-search.png';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import DepartmentActions from '@Actions/departmentActions';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import H3DateSelector from '@Uilib/h3DateSelector';
import ProductActions from '@Actions/productActions';
import { GetPurchaseIndentList } from '../../../../modules/purchase/purchaseIndent.js';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import SelectDepartment from '@Components/Common/SelectDepartment';
import TagSelector from '@Components/Common/Selector/TagSelector';
import useCheckPortrait from '../../../../hooks/useCheckPortrait.jsx';
import PRZSelect from '../../../Common/UI/PRZSelect/index.jsx';
import { ListScreenKeys } from './helpers.jsx';
import MoreInfoMobileView from '../../../Common/MoreInfoMobileView/index.jsx';
import { dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums } from '../../../../apis/constants.js';
import UserSavedFilterViewSelector from '../../../Common/UserSavedFilterViewSelector/index.jsx';
import PRZText from '../../../Common/UI/PRZText/index.jsx';
import './style.scss';

const { Option } = Select;

const fixedColumns = ['PR_NUMBER', 'LOCATION'];

function PurchaseIndentList({
  purchaseIndent,
  getPILoading,
  user,
  customFieldsProps,
  getDocCFV2Loading,
  departments,
  products,
  getProductsLoading,
  getDepartments,
  getDocCFV2,
  getDocCFV2Success,
  getProducts,
  getPurchaseIndent,
  history,
}) {

  const [keyword, setKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchByProduct, setSearchByProduct] = useState('');
  const [selectedProductId, setSelectedProductId] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);
  const [selectedRows, setSelectedRows] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-pi') ? JSON.parse(localStorage.getItem('prcz-page-columns-pi')) : {
    PI_NUMBER: {
      label: 'PI #',
      visible: true,
    },
    LOCATION: {
      label: 'LOCATION',
      visible: true,
    },
    ITEMS: {
      label: 'Item(S)',
      visible: true,
    },
    DATE: {
      label: 'PI Date',
      visible: true,
    },
    LABEL: {
      label: 'Labels',
      visible: true,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
  });
  const [selectedPI, setSelectedPI] = useState({});
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedTag, setSelectedTag] = useState([]);

  // filter states
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);
  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');

  const {
    isMobile,
    isPortrait,
    isMobileAndPortrait,
    isMobileOrPortrait,
  } = useCheckPortrait();

  // common function to get filter value by key
  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {

    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'label',
        filter_value: Helpers.getValueFromUrl('label') ? Helpers.getValueFromUrl('label')?.split(',')?.map((item) => item) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_ids',
        filter_value: Number(Helpers.getValueFromUrl('department_ids')) || '',
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => {
    return [
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: [user?.tenant_info?.tenant_id],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'status',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'label',
        filter_value: [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_ids',
        filter_value: Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility ? Number(Helpers.getDepartmentId(user)) : '',
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'startDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'endDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.PURCHASE_INDENT,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Number(Helpers.getValueFromUrl('limit') || limit));
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
      // setSelectedStatus(Helpers.getValueFromUrl('status'));
      // // setSelectedFulfillmentStatus(Helpers.getValueFromUrl('fulfillment_status'));
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setKeyword(Helpers.getValueFromUrl('keyword'));
      // setStartDate((Helpers.getValueFromUrl('from_date')));
      // setEndDate((Helpers.getValueFromUrl('to_date')));
      // setSelectedTag(Helpers.getValueFromUrl('label') ? Helpers.getValueFromUrl('label')?.split(',')?.map((item) => item) : []);
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'PURCHASE_INDENT',
      };
      getDocCFV2(payload);
      // if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
      //   setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
      //   setSelectedDepartment(Helpers.getValueFromUrl('department_ids') || Helpers.getDepartmentId(user)?.toString());
      // } else {
      //   setSelectedDepartment(Helpers.getValueFromUrl('department_ids'));
      // }

      // setIsUserReady(true);
      setSelectedFilterView(systemDefaultUserView);
    }
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }
        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedStatus(tempFilterValues.status);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setSelectedTag(tempFilterValues.label);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setSelectedDepartment(tempFilterValues.department_ids);

        if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
          setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
          // setSelectedDepartment(Helpers.getValueFromUrl('department') || Helpers.getDepartmentId(user)?.toString());
        } else {
          // setSelectedDepartment(Helpers.getValueFromUrl('department'));
        }
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    // Start a timer with the debounce delay
    const handler = setTimeout(() => {
      if (searchByProduct) {
        getProducts(searchByProduct, user?.tenant_info?.tenant_id, '', 5, 1, '', '', '', '', '', '', '');
      }
    }, 500); // 500ms debounce time
    // Cleanup function to clear the timer
    return () => {
      clearTimeout(handler);
    };
  }, [searchByProduct]);

  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-pi'))?.[customField?.cf_id]?.visible || false,
        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  const pushParamsToUrl = (page, limit, currentTenant, currentDepartment, status, word, start, end, productSearch, tags, orderDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (status) url += `&status=${status}`;
    if (word) url += `&keyword=${word}`;
    if (start) url += `&startDate=${start}`;
    if (end) url += `&endDate=${end}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    if (currentDepartment) url += `&department_ids=${currentDepartment}`;
    if (productSearch) url += `&product_search=${productSearch}`;
    if (tags) url += `&label=${tags}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, selectedTenant, selectedDepartment, selectedStatus, searchKeyword, startDate, endDate, selectedProductId, selectedTag, orderDateSelectedIntervalDateRangeType, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());

      const startDateFormatted = Helpers.getValueFromUrl('startDate') ? dayjs(Number(Helpers.getValueFromUrl('startDate'))).format('YYYY-MM-DD') : "";

      const endDateFormatted = Helpers.getValueFromUrl('endDate') ? dayjs(Number(Helpers.getValueFromUrl('endDate'))).format('YYYY-MM-DD') : "";

      const query = {
        tenant_id: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.READ)?.join(','),
        status: Helpers.getValueFromUrl('status'),
        from_date: startDateFormatted,
        to_date: endDateFormatted,
        page: Helpers.getValueFromUrl('page'),
        limit: Helpers.getValueFromUrl('limit'),
        search_keyword: Helpers.getValueFromUrl('keyword'),
        department_ids: selectedDepartment,
        product_sku_ids: Helpers.getValueFromUrl('product_search'),
        tags: Helpers.getValueFromUrl('label'),
      };
      getPurchaseIndent({query});
    }
  }, [selectedStatus, selectedTenant, selectedDepartment, searchKeyword, currentPage, limit, startDate, endDate, selectedProductId, selectedTag, orderDateSelectedIntervalDateRangeType]);

  const handleChange = (value, option) => {
    setSelectedProductId(value);
    setSelectedProducts(option);
  };

  const materialRequestStatusOptions = [
    { key: '', value: '', label: 'All Purchase Indent' },
    { key: 'DRAFT', value: 'DRAFT', label: 'Draft' },
    { key: 'SENT_FOR_APPROVAL', value: 'SENT_FOR_APPROVAL', label: 'Sent For Approval' },
    { key: 'ISSUED', value: 'ISSUED', label: 'Issued' },
    { key: 'COMPLETED', value: 'COMPLETED', label: 'Closed' },
    { key: 'CANCELLED', value: 'CANCELLED', label: 'Cancelled' },
  ];

  const getDataSource = (data) => {
    if (data) {
      const copyData = [];
      for (let i = 0; i < data?.length; i++) {
        copyData.push({
          ...data?.[i],
          key: data?.[i]?.purchase_indent_id,
        });
      }
      return copyData;
    }
    return [];
  };

  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];

  const getColumns = () => {

    const columns = [
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText className="mobile-list__card_item-number" text={`#${record?.pi_number ? record.pi_number : 'N/A'}`} />
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  style={{ backgroundColor: Helpers.getStatusColor(record?.status)?.color }}
                  text={Helpers.getStatusColor(record?.status)?.text?.toUpperCase()}
                  className="mobile-list__card__status"
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <PRZText
                  text={`Location - ${record?.tenant_info?.tenant_name} (${record?.tenant_department_alias_name})`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Date - ${toISTDate(record?.date).format('DD/MM/YYYY')}`}
                  className="mobile-list__card_item-details"
                />
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              {/* <div className="mobile-list__card_footer-left">
                <PRZText
                  style={{ backgroundColor: Helpers.getStatusColor(record.fulfillment_status).color }}
                  text={Helpers.getStatusColor(record.fulfillment_status).text}
                  className="mobile-list__card_footer__other-status"
                />
              </div> */}
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedPI(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'PI #',
        render: (record) => (
          <div className="min-width-50">
            {record?.pi_number}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PI_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_info?.tenant_name} />
            <H3Text text={record?.tenant_department_alias_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'ITEM(S)',
        render: (text, record) => (
          <div className="min-width-50">
            {record?.lines_count}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ITEMS?.visible ? 'display-none' : '',
      },
      {
        title: 'PI DATE',
        render: (text, record) => (
          <div className="min-width-50">
            {dayjs(record?.pi_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.DATE?.visible ? 'display-none' : '',
      },
      {
        title: 'LABELS',
        render: (item) => (
          <div className="min-width-70">
            <div className="table-labels__list">
              <div>
                <Space size={[0, 8]} wrap>
                  {item?.tags?.map((tag, index) => (
                    <Tag
                      key={index}
                      color={colorArray[index]}
                    >
                      {tag}
                    </Tag>
                  ))}
                </Space>
              </div>
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LABEL?.visible ? 'display-none' : '',
      },
      {
        title: 'STATUS',
        render: (item) => (
          <div className="min-width-70">
            <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item?.status)?.color }}>
              {Helpers.getStatusColor(item?.status)?.text}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.STATUS?.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
    ];
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.filter((item) => item?.is_active)?.map((custom) => {
        columns.push({
          title: custom?.field_name,
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record?.custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    columns.push({
      title: '',
      key: 'action',
      render: (text, record) => (
        <div className="list__actions" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>

          <div
            key={record.pi_id}
            className=" list__actions-button"
              onClick={() => {
                history.push(`/purchase/purchase-indent/create?clonePiId=${record?.pi_id}`);
              }}
          >
            <Tooltip
              placement="topLeft"
              title="Make a Copy"
            >
              <CopyOutlined
                className="action-button"
                style={{
                  justifyContent: 'center',
                  fontSize: '16px',
                }}
              />
            </Tooltip>
          </div>

          <div
            className="list__actions-button list__actions-button-dark"
            onClick={() => {
              history.push(`/purchase/purchase-indent/view/${record?.pi_id}`);
            }}
          >
            View
          </div>
          {/* {user?.tenant_info?.purchase_config?.sub_modules?.purchase_indent?.is_active && (
            <div
              className="list__actions-button mo__action-button"
            >
              {!isRowDisabled(record) ? <UnlockOutlined /> : <LockOutlined />}
            </div>
          )} */}
        </div>
      ),
      className: 'list__actions-column',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isPortrait,
      fixed: 'right',
    });

    return columns.filter((item) => !item.hidden);
  };

  return (
    <Fragment>

      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`PI# ${selectedPI?.pi_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedPI?.custom_fields}
          fields={ListScreenKeys({ documentData: selectedPI })}
        />
      </Drawer>

      <Modal
        title={(
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              alt="shopify icon"
              src={searchIcon} // Make sure 'searchIcon' is defined and imported
              width={20}
              height={20}
              style={{ marginRight: 10 }}
            />
            <div>Search By Product Name</div>
            &nbsp;  &nbsp;
            {getProductsLoading && <Spin size="small" />}
          </div>
        )}
        getContainer={() => document.querySelector('.trigger-modal-btn')}
        style={{
          top: '17px',
          left: isMobileOrPortrait ? '-1%' : '6%',
          width: '520px',
        }}
        open={isModalOpen}
        onOk={() => {
          setIsModalOpen(false);
        }}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        footer={null}
        mask
        maskClosable
        closeIcon={null}
      >
        <div className="section-search">
          <div className="section-search-bar__wrapper" style={{ width: '100%' }}>
            <PRZSelect
              showSearch
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Select a product"
              optionFilterProp="children"
              onSearch={(value) => setSearchByProduct(value)}
              value={selectedProductId}
              onChange={handleChange}
              loading={getProductsLoading}
              filterOption={(input, option) => option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0}
            >
              {products?.result?.products?.map((product) => (
                <Option key={product.product_sku_id} value={product.product_sku_id}>
                  {product?.product_info?.product_sku_name}
                </Option>
              ))}
            </PRZSelect>
          </div>
        </div>
      </Modal>

      <div className='doc-list__wrapper'>
        <div className='ant-row'>
          <div className='ant-col-md-24 ant-col-xs-24'>

            <div className='doc-list__header-wrapper'>

              <div className='doc-list__header-wrapper__left'>

                <div className='section-search'>
                  <div className='doc-list__search-bar__wrapper'>
                    <div className='section-search-bar'>

                      <input
                        value={keyword}
                        placeholder="Search for Purchase Indent..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />

                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className='section-search'>
                  <div className='search-by-product-modal-btn'>
                    <H3Text
                      text={(
                        <div className="new-action-button-wrapper" onClick={() => setIsModalOpen(true)}>
                          <Fragment>
                            <div className="action-button-text">Search By Products </div>
                            <div className="action-button-text_mobile">Search</div>
                            &nbsp;  &nbsp;
                            <H3Image src={searchIcon} className="action-button-icon" />
                          </Fragment>
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>

              <div className="doc-list__header-wrapper__right">
                <div className="doc-list__buttons-wrapper">
                  {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.CREATE, user) && (
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Purchase Indent"
                      onClick={() => history.push('/purchase/purchase-indent/create')}
                      customClass="add-button"
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.orderDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSelectedTenant(tempFilterValues.tenant);
                    setSelectedStatus(tempFilterValues.status);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setStartDate(tempFilterValues.startDate);
                    setEndDate(tempFilterValues.endDate);
                    setSelectedTag(tempFilterValues.label);
                    setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                    setSelectedDepartment(tempFilterValues.department_ids);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.PURCHASE_INDENT}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search results for -
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
                {selectedTag && selectedTag?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTag(selectedTag?.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Label -
                    &nbsp;
                    <span>
                      <b>{item?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {selectedStatus && (
                  <Tag closable onClose={() => { setSelectedStatus(null); setCurrentPage(1); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setSelectedRows([]); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {(startDate && endDate) && (
                  <Tag
                    closable
                    onClose={() => {
                      setStartDate(null);
                      setEndDate(null);
                      setOrderDateSelectedIntervalDateRangeType('');
                    }}
                    color="#2d7df7"
                  >
                    {' '}
                    From:
                    &nbsp;
                    <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                    &nbsp;
                    To:
                    &nbsp;
                    <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                  </Tag>
                )}
                {selectedProductId?.length > 0 && selectedProductId?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setSelectedProductId(selectedProductId?.filter((id) => id !== item));
                    }}
                    color="#2d7df7"
                  >
                    {' '}
                    Product -
                    &nbsp;
                    <span><b>{selectedProducts?.find((product) => product.value === item)?.children}</b></span>
                  </Tag>
                ))}
              </div>
            </div>

            <div className='doc-list__table-wrapper'>
              <Table
                title={() => (
                  <div className='doc-list__table-header'>

                    <div className='doc-list__table-header__left'>
                      <H3Text text={`${(purchaseIndent && purchaseIndent?.count) ? purchaseIndent?.count : '0'} Purchase Indent`} className="" />
                    </div>

                    <div className='doc-list__table-header__right'>
                      <div className='doc-list__filter-buttons'>

                        <H3DateSelector
                          selectedInterval={orderDateSelectedIntervalDateRangeType}
                          startDate={startDate}
                          endDate={endDate}
                          // onDateChange={(date) => {
                          //   setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                          //   setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                          // }}
                          onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                            setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                            setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                            setCurrentPage(1);
                            setOrderDateSelectedIntervalDateRangeType(dateRangeType);
                          }}
                        />

                        <Dropdown
                          trigger={['click']}
                          overlay={(
                            <div className="header__filter__container">

                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>

                              <div className="filter__container filter__container-section">
                                <div className="filter__title"> Select Business Unit </div>
                                <div className="sales-orders__header__section-status">
                                  <TenantSelector
                                    selectedTenant={selectedTenant}
                                    showSearch
                                    showAll={false}
                                    noDropdownAlign
                                    isMultiple
                                    onChange={(value) => {
                                      if (value === 'All') {
                                        setCurrentPage(1);
                                        setSelectedTenant(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.READ));
                                      } else {
                                        setCurrentPage(1);
                                        setSelectedTenant(value);
                                      }
                                    }}
                                    placeholder="Select Business Unit"
                                    hideTitle
                                    includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.READ)}
                                  />
                                </div>
                              </div>

                              <div className="filter__container filter__container-section">
                                <div className="filter__title"> Select Department </div>
                                <div className="sales-orders__header__section-status">
                                  <SelectDepartment
                                    title="Select Department"
                                    hideTitle
                                    selectedDepartment={Number(selectedDepartment) || ''}
                                    noDropdownAlign
                                    onChange={(value) => {
                                      setSelectedDepartment(value?.department_id.toString() || '');
                                      setCurrentPage(1);
                                    }}
                                    disabled={departmentLevelVisibility}
                                  />
                                </div>
                              </div>

                              <div className="filter__container filter__container-section">
                                <div className="filter__title"> Order Status </div>
                                <PRZSelect
                                  value={selectedStatus}
                                  onChange={(value) => {
                                    setSelectedStatus(value);
                                    setCurrentPage(1);
                                  }}
                                  placeholder="Search by status.."
                                  options={materialRequestStatusOptions}
                                />
                              </div>

                              <div className="filter__container">
                                <div className="filter__title"> Select Labels </div>
                                <div className="sales-orders__header__section-status">
                                  <TagSelector
                                    filter
                                    entityType="PURCHASE_INDENT"
                                    selectedTags={selectedTag}
                                    showSearch
                                    showAll={false}
                                    noDropdownAlign
                                    isMultiple
                                    onChange={(value) => {
                                      setCurrentPage(1);
                                      setSelectedTag(value);
                                    }}
                                    placeholder="Select Label"
                                    hideTitle
                                    hideCSS
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        >
                          <div className="doc-list__action-buttons">
                            <div className="action-button">
                              <H3Text text="Filters" className="action-button-text" />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={(value) => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                          localStorage.setItem('prcz-page-columns-pi', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                              {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={(value) => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                            localStorage.setItem('prcz-page-columns-pi', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                bordered
                loading={getPILoading || savedFilterViewsLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && !!getDataSource(purchaseIndent?.purchase_indents)?.length ? { x: 'max-content', y: 'calc(100dvh - 180px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && !!getDataSource(purchaseIndent?.purchase_indents)?.length}
                columns={getColumns()}
                dataSource={getDataSource(purchaseIndent?.purchase_indents) || []}
                pagination={{
                  defaultCurrent: currentPage,
                  current: currentPage,
                  total: purchaseIndent ? purchaseIndent?.count : 0,
                  pageSize: limit,
                  onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setLimit(pageSize);
                  },
                  position: ['bottomLeft'],
                  pageSizeOptions: ['10', '25', '50', '100'],
                  showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  showSizeChanger: true,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, CFV2Reducers, DepartmentReducers, ProductReducers, GetPurchaseIndentList,
}) => ({
  user: UserReducers.user,
  customFieldsProps: CFV2Reducers.cfV2DocPurchaseIndent,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  departments: DepartmentReducers.departments,
  products: ProductReducers.products,
  getProductsLoading: ProductReducers.getProductsLoading,
  purchaseIndent: GetPurchaseIndentList.data,
  getPILoading: GetPurchaseIndentList.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getDepartments: (keyword, tenantId, page, limit, departmentId, callback) => dispatch(
    DepartmentActions.getDepartments(keyword, tenantId, page, limit, departmentId, callback),
  ),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct)),
  getPurchaseIndent: (payload, callback) => dispatch(GetPurchaseIndentList.actions.request(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseIndentList));